// extracted by mini-css-extract-plugin
export default {"fulcrumContainer":"Fulcrum_fulcrumContainer__mMUZ5","fulcrumImage":"Fulcrum_fulcrumImage__6hyq1"};